import React, { useEffect } from "react";
import { withStyles, createStyles, WithStyles, Theme } from "@material-ui/core/styles";

import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";

import IconClose from "@material-ui/icons/Close";
import IconCheck from "@material-ui/icons/Check";

import { genericApi } from "../lib/genericAPI";
import { piinstructiontype } from "../lib/storage/piinstructions";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      padding: `${theme.spacing.unit * 2}px`,
      maxWidth: 720,
      margin: "0 auto",
      width: "100%",
      boxSizing: "border-box",
    },
    header: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: `${theme.spacing.unit}px`,
      paddingBottom: `${theme.spacing.unit}px`,
      marginBottom: `${theme.spacing.unit * 2}px`,
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
    title: {
      fontSize: "1.1rem",
      fontWeight: 600,
      color: theme.palette.text.primary,
    },
    actions: {
      display: "flex",
      gap: `${theme.spacing.unit}px`,
    },
    closeButton: {
      minWidth: "44px",
      backgroundColor: "#ffebee",
      borderColor: "#e53935",
      color: "#c62828",
      "&:hover": {
        backgroundColor: "#ffcdd2",
        borderColor: "#c62828",
      },
    },
    confirmButton: {
      minWidth: "44px",
      backgroundColor: "#43a047",
      color: "white",
      "&:hover": {
        backgroundColor: "#2e7d32",
      },
    },
    facilityCard: {
      padding: `${theme.spacing.unit * 4}px ${theme.spacing.unit * 3}px`,
      textAlign: "center",
    },
    facilityLabel: {
      fontSize: "12px",
      fontWeight: 600,
      letterSpacing: "0.08em",
      textTransform: "uppercase",
      color: theme.palette.text.secondary,
      marginBottom: `${theme.spacing.unit}px`,
    },
    facilityValue: {
      fontSize: "2.25rem",
      fontWeight: 700,
      color: theme.palette.text.primary,
      lineHeight: 1.2,
      wordBreak: "break-word",
    },
    facilityEmpty: {
      fontSize: "1rem",
      color: theme.palette.text.secondary,
      fontStyle: "italic",
    },
  });

type InspectionFacilityProps = {
  piorderid: string;
  packedmarket: string;
  packedcountry: string;
  handleClose: () => void;
  handleConfirm: () => void;
} & WithStyles<typeof styles>;

const InspectionFacilityUnstyled: React.SFC<InspectionFacilityProps> = (props) => {
  const { classes, piorderid, packedmarket, packedcountry, handleClose, handleConfirm } = props;
  const [facility, setFacility] = React.useState("");

  useEffect(() => {
    const piinstructionsGeneric = genericApi<piinstructiontype>("piinstructions");
    piinstructionsGeneric.all().then((piinstructionsLocal) => {
      const resultpiinstructions = piinstructionsLocal
        .filter((item) => item.orgid == piorderid)
        .filter((item) => item.target_market == packedmarket)
        .filter((item) => item.target_country == packedcountry)
        .sort((a, b) => {
          if (a.groupline > b.groupline) return 1;
          if (a.groupline < b.groupline) return -1;
          return 1;
        });
      if (resultpiinstructions && resultpiinstructions.length > 0) {
        setFacility(resultpiinstructions[0].coldroom);
      }
    });
  }, [classes]);

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <Typography component="h2" className={classes.title}>
          Facility
        </Typography>
        <div className={classes.actions}>
          <Button variant="outlined" size="small" className={classes.closeButton} onClick={handleClose}>
            <IconClose />
          </Button>
          <Button variant="contained" size="small" className={classes.confirmButton} onClick={handleConfirm}>
            <IconCheck />
          </Button>
        </div>
      </div>

      <Paper elevation={1} className={classes.facilityCard}>
        <Typography component="div" className={classes.facilityLabel}>
          Cold Room
        </Typography>
        {facility ? (
          <Typography component="div" className={classes.facilityValue}>
            {facility}
          </Typography>
        ) : (
          <Typography component="div" className={classes.facilityEmpty}>
            No facility assigned for this market / country.
          </Typography>
        )}
      </Paper>
    </div>
  );
};

export default withStyles(styles)(InspectionFacilityUnstyled);
